const labels = {
  QrCode: {
    'Ref: Page title': 'MyBus',
    'Ref: Hi': 'Labas',
    'Ref: Page content body':
      'Atvykę ir išvykdami būtinai nepamirškite nuskaityti savo QR kodo magistralės',
  },
};
export default labels;
